import React, { useState } from "react";

const faqData = [
  {
    q: "What services does your digital marketing agency offer?",
    a: "Our digital marketing agency provides complete solutions including website design and development, SEO services, social media marketing, PPC advertising, and content marketing to help businesses grow online.",
  },
  {
    q: "How long does it take to develop a professional website?",
    a: "Basic website design: 1–2 weeks. Business website: 3–5 weeks. Custom or eCommerce: 6+ weeks.",
  },
  {
    q: "How much does a website design and development project cost?",
    a: "Cost depends on features, customization, and functionality. We offer affordable packages for all business sizes.",
  },
  {
    q: "Do you create mobile-friendly and responsive websites?",
    a: "Yes, all websites are fully responsive for mobile, tablet, and desktop.",
  },
  {
    q: "What is SEO and why is it important for my business?",
    a: "SEO improves visibility on Google and increases organic traffic and leads.",
  },
  {
    q: "How long does it take to see results from SEO services?",
    a: "Most businesses see results in 3 to 6 months depending on competition.",
  },
  {
    q: "Do you offer website maintenance and support services?",
    a: "Yes, we provide updates, security, speed optimization, and support.",
  },
  {
    q: "Can you redesign my existing website?",
    a: "Yes, we improve UI, UX, performance, and SEO rankings.",
  },
  {
    q: "Which platforms do you use for web development?",
    a: "We use WordPress, Shopify, and custom React/HTML/CSS development.",
  },
  {
    q: "How do you measure digital marketing success?",
    a: "We track traffic, conversions, rankings, engagement, and ROI.",
  },
  {
    q: "Do you provide social media marketing services?",
    a: "Yes, we manage content, ads, and growth on major platforms.",
  },
  {
    q: "Will I own my website after development?",
    a: "Yes, full ownership is provided to clients.",
  },
  {
    q: "Do you offer customized digital marketing packages?",
    a: "Yes, we build custom strategies based on your business goals.",
  },
  {
    q: "How can I get started with your agency?",
    a: "Contact us for a free consultation and we’ll guide you.",
  },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-gray-100 py-10 sm:py-12 md:py-16 lg:py-20">

      {/* CONTAINER (controls all screen scaling) */}
      <div className="max-w-2xl sm:max-w-3xl md:max-w-4xl lg:max-w-5xl xl:max-w-6xl mx-auto px-4 sm:px-6 md:px-8 lg:px-10">

        {/* TITLE */}
        <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-8 md:mb-10 text-gray-800">
          FAQ About Our Digital Marketing Services
        </h2>

        {/* FAQ LIST */}
        <div className="space-y-3 md:space-y-4">

          {faqData.map((item, index) => (
            <div
              key={index}
              className="border rounded-lg bg-white shadow-sm overflow-hidden"
            >

              {/* QUESTION */}
              <button
                onClick={() => toggle(index)}
                className={`w-full flex justify-between items-center px-4 sm:px-5 md:px-6 py-3 md:py-4 text-left font-medium transition text-sm sm:text-base md:text-lg ${
                  openIndex === index
                    ? "bg-[#f99728] text-white"
                    : "text-gray-800 hover:bg-gray-50"
                }`}
              >
                <span className="pr-4">{item.q}</span>

                <span
                  className={`text-lg font-bold transition-transform duration-300 ${
                    openIndex === index ? "rotate-45" : "rotate-0"
                  }`}
                >
                  +
                </span>
              </button>

              {/* ANSWER */}
              {openIndex === index && (
                <div className="px-4 sm:px-5 md:px-6 py-3 md:py-4 text-xs sm:text-sm md:text-base text-gray-600 bg-white border-t leading-relaxed">
                  {item.a}
                </div>
              )}

            </div>
          ))}

        </div>
      </div>
    </section>
  );
};

export default Faq;